class ResponseData {
  data:any
  error:any
}
export default ResponseData